import BasicRouterView from "../../components/BasicRouterView.vue";

const refactorTablet = {
  path: "ref",
  redirect: { name: "requisicao-lista" },
  meta: {
    label: "Requisição",
    icon: "add_task",
    show: true,
  },
  component: BasicRouterView,
  children: [
    {
      path: "refactor-tablet/lista-cadastrados",
      name: "ref-lista-cadastrados",
      meta: {
        label: "Lista Cadastrados",
        icon: "pending_actions",
        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "ref" */ "./views/ListaTabletsCadastrados.vue"
        ),
    },
  ],
};

export default refactorTablet;
